import {
    FC,
    ReactElement,
    useEffect,
    useState,
} from 'react';

import classNames from 'classnames';

import { Button, Card, RootPortal } from '../../components';
import { clearCaches } from '../../helpers/reload';
import trans from '../../helpers/trans';
import { isNewerVersion } from './helpers';

import './CacheBuster.scss';

interface CacheBusterProps {
    currentVersion: string;
    latestVersion: string;
}

const CacheBuster: FC<CacheBusterProps> = ({
    currentVersion,
    latestVersion,
}): ReactElement => {
    const [shouldUpdate, setShouldUpdate] = useState<boolean>(false);

    useEffect((): void => {
        if (currentVersion && latestVersion) {
            const updateAvailable = isNewerVersion(latestVersion, currentVersion);

            setShouldUpdate(updateAvailable);
        }
    }, [currentVersion, latestVersion]);

    const cacheBusterClassNames = classNames('cache-buster', {
        'cache-buster--is-revealed': shouldUpdate,
    });

    return (
        <RootPortal>
            <section className={cacheBusterClassNames}>
                {shouldUpdate && (
                    <Card className="cache-buster__card">
                        <p className="cache-buster__description">
                            {trans('compositions.cacheBuster.updateAvailable')}
                        </p>

                        <Button
                            text={trans('compositions.cacheBuster.reload')}
                            onClick={clearCaches}
                            className="cache-buster__button"
                        />
                    </Card>
                )}
            </section>
        </RootPortal>
    );
};

export default CacheBuster;
